import React from "react";

import { DotcomApp, SpecialOffersPlacement } from "@swa-ui/dotcom";
import { InflightRetryProvider, WifiAuthenticationProvider } from "@swa-ui/inflight";

import { maintenanceCodes } from "../../defines/maintenanceCodes";
import { InflightUserStatusProvider } from "../../providers";
import { AccountLoginCallToActionCommand } from "../AccountLoginCallToActionCommand";
import { InflightHomePageContainer } from "../InflightHomePageContainer";
import { SpecialOffersSection } from "../SpecialOffersSection";

const basePath = "/inflight/home-page";

export const App = () => {
  return (
    <DotcomApp {...getDotcomAppProps()}>
      <WifiAuthenticationProvider>
        <InflightRetryProvider>
          <InflightUserStatusProvider>
            <InflightHomePageContainer />
          </InflightUserStatusProvider>
        </InflightRetryProvider>
      </WifiAuthenticationProvider>
    </DotcomApp>
  );

  function getDotcomAppProps() {
    return {
      appId: "inflight-home-page",
      appPlacementComponents: {
        "card-list": SpecialOffersSection,
        "special-offer": SpecialOffersPlacement,
      },
      basePath,
      chapi: "inflight-portal",
      chapiVersion: "v1",
      defaultAppSettings: {
        default: {
          disableMetadataCall: true,
          inflightRetryCount: 2,
          inflightRetryDelay: 1000,
          suppressUserInfo: true,
          themeMode: "dark",
        },
      },
      maintenanceCodes,
      placementsConfig: {
        configuredCommands: {
          HOME_PAGE_ACCOUNT_LOGIN: AccountLoginCallToActionCommand,
        },
      },
    };
  }
};
